// Enum define karo
export enum CategoryStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum ApprovalStatus {
  PENDING = "pending",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

// Interface update karo
export interface Category {
  id: number;
  name: string;
  description: string;
  status: ApprovalStatus;
  metalTypeId?: number;

  metalTypeName?: string;
  image?: string | null;
  categortystatus: CategoryStatus
 createdByRole?: string; 
  MetalTypeId?: number;
  metal_type_id?: number;

  //   id: number;
  // name: string;
  // description: string | null;
  // image: string | null;
  // status: string;
  // createdByRole: string | null;
  // isDelete: boolean;
  // createdAt: string;
  // updatedAt: string;
  // categortystatus: CategoryStatus

  // metalTypeId?: number;
  // MetalTypeId?: number;
  // metal_type_id?: number;
}
